export const SPECS = {
  CartTooltipWithoutNumber: 'specs.stores.CartTooltipWithoutNumber',
  CartOOIThunderboltCSSOptimization: 'specs.stores.CartOOIThunderboltCSSOptimization',
  HideDeliveryMethodPickerWithTimeSlots: 'specs.stores.HideDeliveryMethodPickerWithTimeSlots',
  fixEmailNotifierInCart: 'specs.stores.fixEmailNotifierInCart',
  HideCountryPickerInCart: 'specs.stores.HideCountryPickerInCart',
  SupportCardTokenizationOnCartAndCheckout: 'specs.stores.SupportCardTokenizationOnCartAndCheckout',
  ShouldCustomizeCheckoutButton: 'specs.stores.ShouldCustomizeCheckoutButton',
  ShouldUseSideCart: 'specs.stores.ShouldUseSideCart',
  ShouldUseOpenSideCartApiInAddToCart: 'specs.stores.ShouldUseOpenSideCartApiInAddToCart',
  ShouldPreloadCurrentCart: 'specs.stores.ShouldPreloadCurrentCart',
  ShouldUseNewCartQueryAndMutations: 'specs.stores.ShouldUseNewCartQueryAndMutations',
  ShouldUseEcomPlatformPublicApiAddToCartInPP: 'specs.stores.ShouldUseEcomPlatformPublicApiAddToCartInPP',
  UseChevronForItemOptions: 'specs.stores.UseChevronForItemOptions',
  MakeCartItemNameLink: 'specs.stores.MakeCartItemNameLink',
  InvalidCartItemQuantity: 'specs.stores.InvalidCartItemQuantity',
  CartItemMoreOptionsFont: 'specs.stores.CartItemMoreOptionsFont',
  NotShowThreeDotsWhenFinishedLoading: 'specs.stores.NotShowThreeDotsWhenFinishedLoading',
  FixCartItemOptionsBug: 'specs.stores.FixCartItemOptionsBug',
  SendTrackEventWhenCheckoutLoad: 'specs.stores.SendTrackEventWhenCheckoutLoad',
  HandleCartError: 'specs.stores.HandleCartError',
  ErrorMessage: 'specs.stores.AddErrorMessageInCouponWhenTheInputIsEmpty',
  UsePageUrlOnItemThumbnail: 'specs.stores.UsePageUrlOnItemThumbnail',
  ShouldReplaceRemoveIcon: 'specs.stores.ShouldReplaceRemoveIcon',
  ShouldShowIconSizeSetting: 'specs.stores.ShouldShowIconSizeSetting',
  AddSlotToCartPage: 'specs.stores.AddSlotToCartPage',
  FixSSRInCart: 'specs.stores.FixSSRInCart',
} as const;
